var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{on:{"keydown":_vm.onKeyDown}},[_c('v-text-field',{ref:"field",staticClass:"pt-0 mt-0",attrs:{"single-line":"","flat":"","solo":"","hide-details":""},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }